exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question_default:hover .question__circle{stroke:#7884cf}.question_default:hover .question__path{fill:#7884cf}.question__circle,.question__path{transition:.2s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b09209cc","scoped":false,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/svgicon/Question.vue
// module id = 566d347f6908cc78bfad
// module chunks = 5